module.exports = __webpack_public_path__ + "static/media/List.ae62e119.svg";